// extracted by mini-css-extract-plugin
module.exports = {"container":"Footer_container__1vqPO","container_4btn":"Footer_container_4btn__XbuVN","container_authD":"Footer_container_authD__wduoM"};